import { Badge } from "@/components/ui/badge";
import { firStatoLabel, firStatoVariant, type FirRecord } from "@/lib/fir";

export function FirStatoBadge({ fir }: { fir: FirRecord }) {
  const label = firStatoLabel(fir);
  const raw = String(fir.stato_formulario ?? fir.stato ?? "");
  return (
    <Badge variant={firStatoVariant(raw)} className="max-w-[220px] truncate" title={label}>
      {label}
    </Badge>
  );
}
